const newModel = () => {
    return {
        deviceID: null,
        deviceName: null,
        deviceModel: null,
        deviceBrand: null,
        deviceManufacturer: null,
        deviceOs: null,
        deviceOsVersion: null,
        deviceType: null,
        browser: null
    }
}
export const deviceInfoModel = {
    newModel
}
